import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/info.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-728f3792"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "other-amount-title" }
const _hoisted_2 = { class: "amount-to-be-paid-div" }
const _hoisted_3 = { class: "amount-to-be-paid-input-box" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "minimum-amount-title" }
const _hoisted_6 = { class: "other-amount-conditional-messages" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "amount-just-right-text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "superpacman-other-amount-info-icon",
  src: _imports_0
}, null, -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "superpacman-other-amount-warning-text" }
const _hoisted_12 = {
  key: 2,
  class: "superpacman-amount-higher-than-max"
}
const _hoisted_13 = {
  key: 0,
  class: "superpacman-other-amount-warning-text"
}
const _hoisted_14 = {
  key: 1,
  class: "superpacman-other-amount-warning-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('superpacman-other-amount-title')), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.amountToBePaid) = $event)),
          placeholder: _ctx.formattedAmount,
          type: "text",
          inputmode: "numeric",
          class: "amount-to-be-paid-input",
          maxlength: "14"
        }, null, 8, _hoisted_4), [
          [_vModelText, _ctx.amountToBePaid]
        ])
      ]),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('superpacman-minimum-amount')) + ": " + _toDisplayString(_ctx.n(_ctx.minimumAmount, "currency", _ctx.locale)), 1),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.amountJustRight)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, [
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('superpacman-next-payment-date')) + ": " + _toDisplayString(_ctx.$d(_ctx.nextValidThrough, 'medium', _ctx.locale)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.amountLowerThanMinError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('superpacman-minimum-amount-warning')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.amountHigherThanMaxError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_ctx.displayCreditLineMaxAmountMessage)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t('superpacman-max-amount-exceeded-creditline', { creditLinePayoffAmount: _ctx.n(Number(_ctx.maximumAmount), 'currency', _ctx.locale) })), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('superpacman-max-amount-exceeded-cumulative-balance', { fullPayoffAmount: _ctx.n(Number(_ctx.maximumAmount), 'currency', _ctx.locale) })), 1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", _mergeProps({
        class: {'button-grey-bg-white-text': !_ctx.amountJustRight, 'button-green-bg-white-text': _ctx.amountJustRight}
      }, _toHandlers(_ctx.enableClick ? {click: _ctx.handleClick} : {}, true)), _toDisplayString(_ctx.$t('superpacman-confirm-button')), 17)
    ])
  ], 64))
}